const CAN_EDIT_COMPANY = 'can_edit_company';

export { CAN_EDIT_COMPANY };
